import {commonService} from "./common.services";

export  const vignetService = {
    getAllVignets,
    createVignet,
    updateVigName,
    deleteVignets,
    getVignetDetail,
    getGraphData,
    saveTags,
    removeTags,
    saveNote,
    getDashboardGraphData,
    getDashboardShareData,
    getVignetProps,
    getVignetTags,
    getVignetNotes,
    getVignetProjects,
    joinVignets,
    getProjects
}

function getAllVignets(data) {

    return commonService.sendHttpRequest('rbuilder/listvignets', data, "GET");
}

function createVignet(data) {
    return commonService.sendHttpRequest('rbuilder/createvignet', data, "POST");
}


function updateVigName(data) {
    return commonService.sendHttpRequest('rbuilder/updateVignetName', data, "POST");
}

function deleteVignets(data) {
    return commonService.sendHttpRequest('rbuilder/deletevignet', data, "POST");
}

function getVignetDetail(data) {

    return commonService.sendHttpRequest('rbuilder/vignetdetail', data, "GET");
}

function getGraphData(data) {

    return commonService.sendHttpRequest('rbuilder/vignetgraph', data, "GET");
}

function saveTags(data) {

    return commonService.sendHttpRequest('rbuilder/savetags', data, "POST");
}

function removeTags(data) {

    return commonService.sendHttpRequest('rbuilder/removetags', data, "POST");
}

function saveNote(data) {

    return commonService.sendHttpRequest('rbuilder/savenote', data, "POST");
}
function getDashboardGraphData(data) {

    return commonService.sendHttpRequest('rbuilder/dashboardgraph', data, "GET");
}

function getDashboardShareData(data) {

    return commonService.sendHttpRequest('rbuilder/dashboardsharecount', data, "GET");
}
function getVignetProps(data) {

    return commonService.sendHttpRequest('rbuilder/vignetprops', data, "GET");
}
function getVignetTags(data) {

    return commonService.sendHttpRequest('rbuilder/vignettags', data, "GET");
}
function getVignetNotes(data) {

    return commonService.sendHttpRequest('rbuilder/vignetnotes', data, "GET");
}
function getVignetProjects(data) {

    return commonService.sendHttpRequest('rbuilder/vignetprojects', data, "GET");
}
function joinVignets(data) {

    return commonService.sendHttpRequest('rbuilder/joinvignets', data, "POST");
}
function getProjects (data) {

    return commonService.sendHttpRequest('rbuilder/listprojects', data, "GET");
}


// WEBPACK FOOTER //
// ./src/services/vignets.services.js